import { Icon, Tooltip } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import classNames from 'classnames';

import ContractorCell from './cells/ContractorCell';
import ChangingHistory from '../../../components/ChangingHistory/ChangingHistory';
import AuthorCell from './cells/AuthorCell';

import getHistory from '../requests/getHistory';
import getLastComment from '../requests/getLastComment';
import documentEditMode from '../constants/documentEditMode';

import styles from './table.module.scss';
import CommentsModal from '../../../components/commentsChat/CommentsModal/CommentsModal';
import CommentsChatFooter from '../../../components/commentsChat/commentsFooter/CommentsChatFooter/CommentsChatFooter';
import {
  getDocumentCommentsAction,
  sendDocumentCommentAction,
} from '../../../actions/commentsActions/documentsCommentsActions/documentsCommentsActions';
import { useDispatch, useSelector } from 'react-redux';
import { setEntityIdAction } from '../../../actions/commentsActions/commentsActions';
import LastComment from '../../../components/commentsChat/LastComment/LastComment';
import AttachmentsCell from './cells/AttachmentsCell';
import { ExpandedRowDocVisibility } from './ExpandedRowDocVisibility';
import { ExpandedRowDocReminder } from './ExpandedRowDocReminder';
import { ExpandedRowDocRelated } from './ExpandedRowDocRelated';
import ExpandedRowDocSource from './ExpandedRowDocSource';

const ExpandedRow = ({ record, rowOpened, trProps }) => {
  const [changingHistoryOpened, setChangingHistoryOpened] = useState();
  const [chatOpened, setChatOpened] = useState(false);
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.authentication.userInfo);
  const isAuthor = record.createUser.id === +userInfo.WorkerId;

  const sendComment = useCallback(
    (entityId, message, attachedFiles, isEdit) => {
      dispatch(
        sendDocumentCommentAction(entityId, message, attachedFiles, isEdit)
      );
    },
    []
  );

  const closeCommentsModal = () => {
    setChatOpened(false);
  };

  const openCommentsModal = () => {
    setChatOpened(true);
  };

  const footerNode = (
    <CommentsChatFooter
      entityId={record.id}
      sendComment={sendComment}
      showCheckboxOptions={false}
    />
  );

  const lightboxConfig = useMemo(
    () => ({
      url: `/docs/attachment`,
      props: { docId: record.id, fileName: '' },
    }),
    [record.id]
  );

  return (
    <tr
      {...trProps}
      className={classNames(
        trProps.className,
        'dspx-expanded-table-row',
        styles.expandedRow,
        `dspxExRow${record.id}`
      )}
    >
      <td colSpan={1} />
      <td
        colSpan={1}
        style={{
          verticalAlign: 'bottom',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: '4px',
        }}
      >
        <div
          className={styles.iconCover}
          style={{ marginBottom: '8px' }}
        >
          <ExpandedRowDocSource record={record} />
        </div>
        <div
          className={styles.iconCover}
          style={{ marginBottom: '8px' }}
        >
          <ExpandedRowDocRelated record={record} />
        </div>
        {isAuthor && (
          <div
            className={styles.iconCover}
            style={{ marginBottom: '8px' }}
          >
            <ExpandedRowDocReminder record={record} />
          </div>
        )}
        <div
          className={styles.iconCover}
          style={{ marginBottom: '8px' }}
        >
          <ExpandedRowDocVisibility record={record} />
        </div>
        <div className={styles.iconCover}>
          <Tooltip
            title="История изменений"
            placement="right"
          >
            <Icon
              onClick={(e) => {
                e.stopPropagation();
                setChangingHistoryOpened(true);
              }}
              type="history"
              className={classNames(styles.icon, styles.historyIcon)}
            />
          </Tooltip>
          <ChangingHistory
            hide={() => setChangingHistoryOpened(false)}
            visible={changingHistoryOpened}
            doc={record}
            getHistory={getHistory}
          />
        </div>
      </td>
      <td
        colSpan="3"
        className={styles.topTd}
      >
        <AttachmentsCell record={record} />
      </td>
      <td
        colSpan="2"
        className={styles.topTd}
      >
        <LastComment
          onClick={openCommentsModal}
          setEntityIdAction={setEntityIdAction}
          getEntityCommentsAction={getDocumentCommentsAction}
          entityId={record.id}
          getLastComment={getLastComment}
          withBorder={false}
          withTitle
        />
        <CommentsModal
          lightboxConfig={lightboxConfig}
          visible={chatOpened}
          onClose={closeCommentsModal}
          title={`Комментарии • ${record.docNumber}`}
          footer={footerNode}
        />
      </td>
      <td colSpan={2}>
        <ContractorCell
          rowOpened={rowOpened}
          record={record}
          documentEditMode={documentEditMode}
        />
      </td>
      <td
        colSpan={1}
        style={{ borderTopRightRadius: 0, borderBottomRightRadius: '4px' }}
      >
        <AuthorCell
          record={record}
          textStyle={{ lineHeight: '19px' }}
        />
      </td>
      <td colSpan={1} />
    </tr>
  );
};

export default ExpandedRow;
